import AltInstance from '../../../../Common/Globals/Scripts/AltInstance';
import CsvImportActions from '../Actions/CsvImportActions';
import ActionInProgressActions from '../../../../Common/Actions/ActionInProgressActions';

export class CsvImportStore {
    constructor() {
        this.bindActions(CsvImportActions);
        this.bindActions(ActionInProgressActions);
        this.resetStore();
    }

    resetStore() {
        this.validationErrors = [];
        this.importInProgress = false;
        this.importSucceeded = false;
        this.file = null;
        this.fileName = null;
    }

    onImportStarted() {
        this.importInProgress = true;
        this.file = null;
    }

    onImportFailed(validationErrors) {
        this.importInProgress = false;
        this.validationErrors = validationErrors;
    }

    onImportSucceeded() {
        this.importInProgress = false;
        this.importSucceeded = true;
    }

    onFileSelected(file) {
        this.resetStore();
        this.file = file;
        this.fileName = file.name;
    }

    onCancelImport() {
        this.resetStore();
    }
}

export default AltInstance.createStore(CsvImportStore, 'CsvImportStore');
